import AppRecord from './AppRecord.js'

class DataStaging extends AppRecord {
}
export default DataStaging
